export default "__VITE_ASSET__83c06271__"